import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workExtraTypeGrid: [],
    workExtraTypeAll: [],
    workExtraTypeShow: null,
    pageData: null,
  },
  mutations: {
    setWorkExtraTypeGrid(state, payload) {
      state.workExtraTypeGrid = payload
    },
    setWorkExtraTypeAll(state, payload) {
      state.workExtraTypeAll = payload
    },
    setWorkExtraTypeShow(state, payload) {
      state.workExtraTypeShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
  },
  getters: {
    workExtraTypeGrid: (state) => {
      return state.workExtraTypeGrid
    },
    workExtraTypeAll: (state) => {
      return state.workExtraTypeAll
    },
    workExtraTypeShow: (state) => {
      return state.workExtraTypeShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkExtraTypeGrid({ commit, rootState }, { limit, page, sort, search }) {
      commit('setLoadingAnimation', true, { root: true })
      let url =
        rootState.apiDomain + '/api/admin/work/extra/type/grid?limit=' + limit + '&page=' + page
      if (sort) {
        url = url + '&order[]=' + sort.param + ':' + sort.value
      } else {
        url = url + '&order[]=name:asc'
      }
      if (search) url = url + '&search=' + search
      return new Promise((resolve, reject) => {
        axios({
          url,
          limit: limit,
          page: page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkExtraTypeGrid', resp.data.data)
            commit('setPageData', resp.data)
            commit('setLoadingAnimation', false, { root: true })
            resolve(resp)
          })
          .catch((err) => {
            commit('setLoadingAnimation', false, { root: true })
            reject(err)
          })
      })
    },
    onWorkExtraTypeAll({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain + '/api/admin/work/extra/type/grid?limit=0' + '&order[]=name:asc',
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkExtraTypeAll', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkExtraTypeShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/extra/type/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkExtraTypeShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkExtraTypeCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/extra/type',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkExtraTypeUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/extra/type',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkExtraTypeDelete({ rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/extra/type/' + id,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
